import React from "react";
const HamburgerIcon = () => {
  return (
    <svg focusable="false" viewBox="0 0 24 24">
      <path
        d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
        fill="#5F6368"
      ></path>
    </svg>
  );
};

export default HamburgerIcon;
